import React from 'react';
import cn from 'classname';
import { connect } from 'react-redux';
import moment from 'moment';

const ExpandedRow = ({ row, toggleExpandedRow }) => (
	<tr
		className={cn({ 'row-done': row.status === 'done', 'row-declined': row.status === 'declined' })}
	>
		<td
			className={`id fixed-col ${cn({
				'col-done': row.status === 'done', 'col-declined': row.status === 'declined',
				'hover-pointer': true
			})}` }
			onClick={toggleExpandedRow.bind(null, row.id)}
		>
		</td>
		<td className="approve_request_cell">
			<span>{moment(row.date).format('YYYY-MM-DD')}</span>
		</td>
		<td className="approve_request_cell"></td>
		<td className="approve_request_cell"> { row.toApproveCount }</td>
		<td className="approve_request_cell"> { row.total }</td>
		<td className="approve_request_cell"> { row.pending }</td>
		<td className="approve_request_cell">
			<span>{row.payoutSum} usd</span>
		</td>
		<td className="approve_request_cell"></td>
		<td className="approve_request_cell"></td>
		<td className="approve_request_cell">
			<span>{Math.floor(10000 * (row.toApproveCount + row.approved)/ row.total)/100} %</span>
		</td>
		<td className="approve_request_cell"></td>
		<td className="approve_request_cell"></td>
		<td className="approve_request_cell"></td>
		<td className="approve_request_cell"></td>
		<td></td>
		<td className="approve_request_cell"></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
	</tr>
);

export default connect(state => ({ requestTypes: state.root.lists['manual-approve-request-types'] }))(ExpandedRow);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/conversions-approve-requests/components/table/expanded-row.js